/**
 * @deprecated Use PRODUCT_ROUTES instead
 */
export const PRODUCT = {
  HOME: 'product',
  HOME_JP: 'product_jp',
  MASTER_PP: 'master-pp',
  VISIBLE_BY_VERIZON_DRAWER: 'visible_by_verizon_drawer',
  PROCESSOR_DRAWER: 'processor_drawer',
  OBSOLETE_DRAWER: 'obsolete_drawer',
}

export const PRODUCT_ROUTES = {
  DEV_ONLY_VARIANT_PRODUCT_PAGE: 'dev_only_variant_product_page',
  DEV_ONLY_MASTER_PRODUCT_PAGE: 'dev_only_master_product_page',
  VARIANT_PRODUCT_PAGE_GLOBAL: PRODUCT.HOME,
  VARIANT_PRODUCT_PAGE_JP: PRODUCT.HOME_JP,
  MASTER_PRODUCT_PAGE: PRODUCT.MASTER_PP,
  WEBVIEWS_VISIBLE_BY_VERIZON_DRAWER: PRODUCT.VISIBLE_BY_VERIZON_DRAWER,
  WEBVIEWS_PROCESSOR_DRAWER: PRODUCT.PROCESSOR_DRAWER,
  WEBVIEWS_OBSOLETE_DRAWER: PRODUCT.OBSOLETE_DRAWER,
}
